import dayjs from 'dayjs';
import { getAuthHeader } from '~/modules/common/utils/cookieUtils';
const { HmacSHA256 } = require('jscrypto/HmacSHA256');

export const getGameApiHeaderHash = ({ o, t, v, ts }) => {
  const sk = 'ec9c9a64f4e41a4b0752c54839531835';
  const hash = HmacSHA256(`${o}:${t}:${ts}:${v}`, sk).toString();
  return hash;
};

export const getGameApiHeaders = (cookies) => {
  if (!getAuthHeader(cookies).Authorization) return {};

  const TARGET_HASH_TIMESTAMP = dayjs().unix();
  const USER_TOKEN = getAuthHeader(cookies).Authorization.split(' ')[1];
  const ORGANIZATION = 'onedio';
  const TARGET_HASH_VERSION = 'v1';
  const TARGET_HASH = getGameApiHeaderHash({ o: ORGANIZATION, t: USER_TOKEN, v: TARGET_HASH_VERSION, ts: TARGET_HASH_TIMESTAMP });
  return {
    'games-app-organization': ORGANIZATION,
    'games-app-user-token': USER_TOKEN,
    'games-app-h': TARGET_HASH,
    'games-app-hv': TARGET_HASH_VERSION,
    'games-app-ts': TARGET_HASH_TIMESTAMP,
  };
};
